// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import {
  ImportDetailRowsResultDto,
  ScritturaElisioneDto,
} from '@ideapa/common-dto';
import { SelectItem } from '@ideapa/common-interfaces';
import { Observable, map } from 'rxjs';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ScritturaElisioneApiClient extends BaseCRUDApiClient<ScritturaElisioneDto> {
  baseUrl = this.config.apiEndpoint + '/scrittura-elisione';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getSoggetti() {
    return this.http.post<SelectItem[]>(`${this.baseUrl}/soggetti`, {});
  }

  calcolaPercentuale(soggettoA: string, soggettoB: string) {
    this._pagedCache.clear();
    return this.http.post<number>(`${this.baseUrl}/calcola-percentuale`, {
      soggettoA,
      soggettoB,
    });
  }

  downloadPdfElisione(fileName: string): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-pdf-elisione',
        {
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        }
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  cancellazioneScrittureElisione() {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/cancella-scritture`);
  }

  importExcelFile(
    file: File,
    idSoggettoA: string,
    idSoggettoB: string,
    percConsolidamento: number
  ) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('idSoggettoA', idSoggettoA);
    fd.append('idSoggettoB', idSoggettoB);
    fd.append('percConsolidamento', percConsolidamento.toString());
    return this.http.post<ImportDetailRowsResultDto>(
      this.baseUrl + '/import-excel',
      fd
    );
  }
}
